export default "__VITE_ASSET__c992340a__"